// extracted by mini-css-extract-plugin
module.exports = {"container":"_3jU7LHQAFgsjy0t2QSVFUG","name":"fahAOBEtcJXL_vQiK4fah appTitle","products":"Jw-GQ1r-mZqgls-nIWFlc","menuProductCol":"_2gA2q6LFKNg_089WQ7zI7k"};